module.exports = __webpack_public_path__ + "static/vuejs-e6d34002b0c7e3be8ec3a0f92fe2ae03.png";